export default __webpack_public_path__ + "static/media/tickets.c6614b03.svg";